import React from "react";
import { Helmet } from "react-helmet-async";

export default function PrivacyPolicy() {
  return (
    <main className="max-w-4xl mx-auto px-6 py-16">
      {/* ============================
          SEO
      ============================ */}
      <Helmet>
        <title>Privacy Policy | Aerzen Air™</title>
        <meta
          name="description"
          content="Learn how Aerzen Air™ collects, uses, and protects your personal information. We are committed to data privacy and security."
        />
        <link
          rel="canonical"
          href="https://www.aerzenair.com/privacy"
        />
      </Helmet>

      <h1 className="text-3xl font-bold mb-6">Privacy Policy</h1>

      <p className="text-gray-700 mb-4">
        AERZEN AIR™ respects your privacy and is committed to protecting your
        personal information.
      </p>

      <h2 className="font-semibold text-xl mt-6 mb-2">Data Collection</h2>
      <p className="text-gray-700 mb-4">
        We may collect personal details such as name, contact number, email
        address, and city solely for order processing and customer support.
      </p>

      <h2 className="font-semibold text-xl mt-6 mb-2">Data Usage</h2>
      <p className="text-gray-700 mb-4">
        Your data is used only for internal operations and is never sold or
        shared with third parties except where required for payment processing
        or legal compliance.
      </p>

      <h2 className="font-semibold text-xl mt-6 mb-2">Security</h2>
      <p className="text-gray-700 mb-4">
        We use industry-standard measures to safeguard your information.
      </p>

      <p className="text-gray-500 text-sm mt-8">
        Last updated: {new Date().toLocaleDateString("en-IN")}
      </p>
    </main>
  );
}
